module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_oslo_viken_neg.f5e77148.png";